import { useNavigate, useSearch } from "@tanstack/react-router";
import { ViewToggle } from "@/components/ui/PageHeader/ViewToggle";
import type { ViewOption } from "@/components/ui/PageHeader/types";
import type { AuditDetailTab } from "@/packages/types";
import { useTranslation } from "@/packages/utils";

export const AUDIT_DETAIL_TABS = [
  "overview",
  "checklist",
  "documents",
  "clauses",
  "findings",
  "activity",
] as const;

export function useTabNavigation() {
  const { t } = useTranslation(["audits"]);
  const { tab } = useSearch({ from: "/$workspaceSlug/audits/$auditId" });
  const navigate = useNavigate({ from: "/$workspaceSlug/audits/$auditId" });

  const viewOptions: ViewOption[] = AUDIT_DETAIL_TABS.map((id) => ({
    id,
    label: t(`audits:detail.tabs.${id}`),
    active: id === (tab ?? "overview"),
  }));

  const handleViewChange = (id: string) => {
    navigate({ search: { tab: id as AuditDetailTab }, replace: true });
  };

  return { viewOptions, handleViewChange };
}

export function AuditDetailTabs() {
  const { viewOptions, handleViewChange } = useTabNavigation();
  return <ViewToggle options={viewOptions} onViewChange={handleViewChange} />;
}
